module.exports = __webpack_public_path__ + "img/ctrl-aggregate-dagger-stub--.4b102989.svg";